@if (liProfile) {
<div class="empty-img">{{ firstChar }}</div>
} @if (detailProfile) {
<div class="empty-profile-icon">{{ firstChar }}</div>
} @if (detailHeadProfile) {
<div class="empty-head-icon" id="empty-head-icon">{{ firstChar }}</div>
}
